import {useContext, useEffect, useState} from "react";
import {UserContext} from "../../../../hooks/Context/UserContext";
import {PermissionType} from "../../../../constants/types/PermissionType";
import MenuLayout from "../../../Menu/MenuLayout";
import {
  CplApplicantMenuOptions,
  CplApplicantMarketplaceMenuOptions,
  CplApplicantOnlyMarketplaceMenuOptions, UploadDocumentsMenuOption
} from "../../../../constants/menuOptions/CplApplicantMenuOptions";
import {useQueryUserInfo} from "../../../../api/admin/useQueryUserInfo";
import {PortfolioContext, PortfolioStatusTypes} from "../../../../hooks/Context/PortfolioContext";
import Loading from "../../../UI/Loading/Loading";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import {isMarketplaceUrl} from "../../../../lib/envFunctions/isMarketplaceUrl";
import SoftUserHeader from "../../../Headers/SoftUserHeader";
import Footer from "../../../Footer";
import {useDocumentRequests} from "../../../../api/cpl-applicant/useQueryDocumentRequests";
import {useQueryApplicantPortfolios} from "../../../../api/admin/useQueryApplicantPortfolios";
import "./CplApplicantLayout.css"

const CplApplicantLayout = () => {
  const navigate = useNavigate();
  const {pathname} = useLocation();
  const [user] = useContext(UserContext);
  const [portfolio, setPortfolio] = useContext(PortfolioContext);
  const {refetch} = useQueryUserInfo({});
  const [showLoading, setShowLoading] = useState<boolean>(true);
  const {data: documentsRequested} = useDocumentRequests();
  const {data: portfolios} = useQueryApplicantPortfolios({user_id: user.id ? user.id : ''});

  useEffect(() => {
    if (!user.isSoft) {
      if ((user.user_id || user.id) && (showLoading || (!portfolio.id && user.permission_groups?.includes(PermissionType.cpl_applicant)))) {
        refetch().then(response => {
          if (!response.isError || response?.failureReason?.message !== 'no access token') {
            if (response && response.isError) {
              throw new Error('portfolio not valid');
            } else {
              setShowLoading(false);
              if (response.data && !portfolio.start_over) {
                setPortfolio({
                  ...response.data,
                  start_over: portfolio.start_over ? portfolio.start_over : response.data.start_over,
                });
              }
            }
          }
        }).catch(() => {
          setPortfolio({
            status: PortfolioStatusTypes.not_created,
            id: 'unset',
          });
          setShowLoading(false);
        });
      }
    } else {
      if (!portfolio.id || portfolio.id === 'unset') {
        let savedId = localStorage.getItem('portfolio_id');
        let marketplaceUser = !!localStorage.getItem('marketplace_user');
        if (savedId) {
          setPortfolio({
            ...portfolio,
            id: savedId,
            marketplaceUser: marketplaceUser
          });
          if (isMarketplaceUrl()) {
            navigate('/cpl-applicant/marketplace');
          } else if (pathname === '/cpl-applicant' || pathname === '/cpl-applicant/my-programs') {
            setTimeout(() => {
              navigate('/cpl-applicant');
              setTimeout(() => {
                navigate('/cpl-applicant/my-programs');
              }, 0)
            }, 100)
          }
        }
      }
    }
  }, [user, portfolio, showLoading]);


  if (user.isSoft || !localStorage.getItem('refresh')) {
    return <div className="full-height-layout">
      <SoftUserHeader/>
      <div
        style={pathname !== '/cpl-applicant' ? {padding: window.screen.width >= 1024 ? '24px 100px 48px' : '24px'} : {}}>
        <Outlet/>
      </div>
      <Footer/>
    </div>
  }

  if (!showLoading && user?.permission_groups && user?.permission_groups?.length > 0) {
    if (user.permission_groups?.includes(PermissionType.cpl_applicant)) {
      return <MenuLayout
        menuOptions={[
          ...(user?.permissions?.includes("is_marketplace_user")
            ? isMarketplaceUrl()
              ? CplApplicantOnlyMarketplaceMenuOptions
              : CplApplicantMarketplaceMenuOptions
            : CplApplicantMenuOptions(portfolios ? portfolios : [])),
          ...(
            documentsRequested && documentsRequested.unresolved_document_requests > 0
              ? [UploadDocumentsMenuOption]
              : []
          )
        ]
        }
      />
    } else {
      navigate('/');
    }
  }

  return <Loading loading/>;
}

export default CplApplicantLayout;